import dayjs, { Dayjs } from 'dayjs';
import { CreateCampaignStore } from 'store/CreateCampaignStore';
var utc = require('dayjs/plugin/utc');
var timezone = require('dayjs/plugin/timezone'); // dependent on utc plugin
dayjs.extend(utc);
dayjs.extend(timezone);

export const convertDateToUTCTimestamp = (date: Dayjs) => {
  // @ts-ignore
  return dayjs.utc(date).tz('Europe/London');
};

export const convertSendDate = (
  sendDate: Dayjs | null,
  sendTime: Dayjs | null
) => {
  if (
    sendDate &&
    sendTime &&
    typeof sendDate !== 'string' &&
    typeof sendTime !== 'string'
  ) {
    const combinedSendDate = sendDate
      .set('hour', sendTime.hour())
      .set('minute', sendTime.minute())
      .set('second', sendTime.second());
    return combinedSendDate.unix();
  }
  if (sendDate && sendTime) {
    const combinedSendDate = dayjs(sendDate)
      .set('hour', dayjs(sendTime).hour())
      .set('minute', dayjs(sendTime).minute())
      .set('second', dayjs(sendTime).second());
    return combinedSendDate.unix();
  }
  return null;
};

export const campaignMessagePayload = (
  text: string | null,
  campaign_id: string | null,
  title: string | null
) => {
  return {
    ...(text && { text }),
    ...(campaign_id && { campaign_id }),
    ...(title && { title }),
  };
};

export const replaceUrl = (text: string) => {
  const urlRegex = /(https?|ftp):\/\/[^\s/$.?#].[^\s]*/gi;
  return text.replace(urlRegex, 'https://brz.ai/XXXXXX/YYYYYY');
};

export const isCampaignIncomplete = (
  data: Omit<CreateCampaignStore, 'actions' | 'hasCredits'>
) => {
  const commonChecks =
    !data.name ||
    !data.stores ||
    data.stores.length === 0 ||
    !data.sendDate ||
    !data.audience ||
    !data.sendTime;

  if (data.selectedChannel === 'sms') {
    return (
      commonChecks ||
      !data.messageEncoding ||
      data.messageEncoding.trim() === '' ||
      !data.previewMessage ||
      data.previewMessage.trim() === '' ||
      typeof data.estimatedReachableUsers !== 'number' ||
      !data.messagesQuantity ||
      data.messagesQuantity.trim() === ''
    );
  }

  if (data.selectedChannel === 'push') {
    return commonChecks;
  }

  return false;
};

// function to replace all '<br>' and '\n' with space character to count characters
export const replaceBreakLine = (text: string) => {
  return text.replaceAll('<br>', ' ').replaceAll('\n', ' ');
};
